import { jsx as _jsx } from "react/jsx-runtime";
import React, { memo } from 'react';
import styles from '../GlucoseConcentrationLevels.pcss';
const LinkEndLine = ()=>/*#__PURE__*/ _jsx("div", {
        className: styles.link,
        children: /*#__PURE__*/ _jsx("div", {
            className: styles.link__endLine
        })
    });
export default /*#__PURE__*/ memo(LinkEndLine);
